
import { Component, OnInit, Input} from '@angular/core';
import { S3UploadService } from 'shared/services/s3-upload.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'environments/environment';
import { PreloaderService } from 'shared/services/preloader.service';
import axios from 'axios';
import { ModalService } from 'shared/services/modal.service';
import { delivareblesBlockreason, delivareblesNAreason } from 'shared/models/static-list-data.service';
import { AlertService } from 'shared/services/alert.service';
import { DocumentApi } from 'shared/sdk';
import { AuthService } from 'shared/services/authentication.service';
interface UploadedFile {
  name: string;
  size: string;
  status: string;
}
@Component({
  selector: 'app-job-deliverable',
  templateUrl: './job-deliverables.component.html',
  styleUrls: ['./job-deliverables.component.css']
})
export class JobDeliverableComponent implements OnInit {
  statusCounts: { [status: string]: number } = {};
  @Input()
  set selectedJob(e) {
    this._selectedJob = e;
    // console.log(e)
    this.getDeliverables(e.id)
  }
  _selectedJob: any;
  selectedFiles: File[] = [];
  progress = {};
  deliverablesForm: FormGroup;
  deliverableList = [];
  isLoading = true;
  currentUser: any;
  selectedFilesNames: { [key: number]: File[] } = {};
  showReason = false;
  deliverablesReason: any;
  textlabel = '';
  textHeader = '';
  deliverablesStatus = '';
  selectedId = '';
  formErrors: any = {};
  validationMessages = {};
  showOther = false;
  isCompleteDeliverable= false;
  maxFiles = 10;
  files: UploadedFile[] = [];
  notes = '';
  documentId=[];
  submittedCount = 0;
  constructor(private s3Service: S3UploadService,
    private _fb: FormBuilder,
    private _preloaderService: PreloaderService,
    private _modalService: ModalService,
    private _alertService: AlertService,
    private _documentApi:DocumentApi,
    private auth: AuthService
  ) { }
  ngOnInit() {
    const appData = JSON.parse(localStorage.getItem('appData'));
    this.currentUser = appData && appData.user;
  }

  initializeForm() {
    this.deliverablesForm = this._fb.group({
      reasonlist: [null, [Validators.required]],
      notes:[null]
    });
    this.setFormErrors();
  }

  getDeliverables(jobId) {
    this._preloaderService.showPreloader();
    const url = environment.phoenixURL + '/jobs/' + jobId + '/deliverables';
    const that = this;

    axios.get(url)

      .then(function (response) {
        that.isLoading = false;
        that._preloaderService.hidePreloader();
        that.deliverableList = response.data && response.data.data ? response.data.data : [];
        that.statusCounts = that.getStatusCounts(that.deliverableList);
        const pendingCount = that.statusCounts['pending'] || 0;
        const approvedCount = that.statusCounts['approved'] || 0;
        that.submittedCount = that.deliverableList.length - (pendingCount + approvedCount);
      }).catch(function (error) {
        that.isLoading = false;
        that._preloaderService.hidePreloader();
      });
  }


  onFileSelected(event, index) {
    const file: File = event.target.files[0];
    this.selectedFiles = Array.from(event.target.files);
    this.selectedFilesNames[index] = Array.from(event.target.files);
  }

  upload(delId) {
    this.selectedFiles.forEach(file => {
      this.s3Service.getPresignedUrl(file).subscribe((res: any) => {
        this.s3Service.uploadToS3(res.data.url, file).subscribe((event: any) => {
          //after file upload send detail in document model then call delivarebles
          if (event && event.status && event.status == 200) {
            const fileObj = res.data;
            const docBody = {
              s3Key:res.key,
              fileMeta:{
                name: res.key,
                type: file.type,
                size: file.size,
                path: fileObj.url,
              },
              modelId:delId,
              modelName:'Deliverable',
              container:'serviceo-uploads',
              categoryId:'35',
              subCategoryId:'203',
              shortUrl:fileObj.url
            }
            this._preloaderService.showPreloader();
            this._documentApi.saveS3Document(docBody).subscribe(docRes => {
              this._preloaderService.hidePreloader();
              const docIds = (docRes.data && docRes.data.docmnt) ? docRes.data.docmnt: "";
              this.documentId.push(docIds);
            }, err => {
              this._preloaderService.hidePreloader();
              this._alertService.error('Please try again .');
            })
          }

        });
      });
    });
  }

  closePopup() {
    this._modalService.closed();
  }

  saveDeliverables(delId, postBody) {
    this._preloaderService.showPreloader();
    const url = environment.phoenixURL + '/jobs/' + this._selectedJob.id + '/deliverables/' + delId + '/submit';
    const that = this;
    axios.post(url, postBody).then(function (response) {
      that._alertService.success('Deliverable submitted successfully.');
      that._preloaderService.hidePreloader();
      that.showReason = false;
      that.isCompleteDeliverable = false;
      that.getDeliverables(that._selectedJob.id)
    }).catch(function (error) {
      that._preloaderService.hidePreloader();
      that._alertService.error('Please try again .');
    });
  }

  updateDeliverableStatus(id, status) {
    this.initializeForm();
    this.showReason = true;
    this.isCompleteDeliverable = false;
    if (status == 'na') {
      this.textHeader = 'All collected logs, images and documents uploaded to customer portal(bundle on USB backup)';
      this.textlabel = 'Select a reason';
      // this.deliverablesForm.get('notApplicableReasonText').setValidators([Validators.required]);
      // this.deliverablesForm.get('notApplicableReasonText').updateValueAndValidity();
      // this.deliverablesForm.get('blockedReasonText').clearValidators();
      // this.deliverablesForm.get('blockedReasonText').updateValueAndValidity();
      this.deliverablesReason = delivareblesNAreason;
      this.deliverablesStatus = 'not_applicable';
    }
    else if (status == 'blocked') {
      this.textHeader = 'All collected logs, images and documents uploaded to customer portal(bundle on USB backup)';
      this.textlabel = 'Select a blocking reason';
      // this.deliverablesForm.get('blockedReasonText').setValidators([Validators.required]);
      // this.deliverablesForm.get('blockedReasonText').updateValueAndValidity(); 
      this.deliverablesReason = delivareblesBlockreason;
      this.deliverablesStatus = 'blocked';

    }
    else if (status == 'upload') {
      this.textHeader = 'Photo of asset tag and serial number(before work)';
      this.textlabel = '';
      this.isCompleteDeliverable = true;
      this.deliverablesForm.controls['reasonlist'].setValidators(null);
      this.deliverablesForm.controls['reasonlist'].setValue(null);
      this.deliverablesForm.get('reasonlist').updateValueAndValidity();
    }
    this.selectedId = id;
    
  }


  submitRequest() {
    this._preloaderService.showPreloader();
    const data = this.deliverablesForm.value;
    const url = environment.phoenixURL + '/jobs/' + this._selectedJob.id + '/deliverables/' + this.selectedId;
    let postBody = {};
    if (this.deliverablesStatus == 'not_applicable') {
      postBody = {
        status: this.deliverablesStatus,
        notApplicableReasonText: data.reasonlist
      }
    } else if (this.deliverablesStatus == 'blocked') {
      postBody = {
        status: this.deliverablesStatus,
        blockedReasonText: data.reasonlist
      }
    }

    if(this.isCompleteDeliverable){
      const postBody = {
        documentIds: this.documentId,
        status: 'submitted',
        submissionNotes: this.deliverablesForm.value.notes
      }
      this.saveDeliverables(this._selectedJob.id,postBody);

    } else {
      const that = this;
      axios.post(url, postBody).then(function (response) {
        that._alertService.success('Deliverable submitted successfully.');
        that._preloaderService.hidePreloader();
        that.showReason = false;
        that.getDeliverables(that._selectedJob.id)
      }).catch(function (error) {
        that._preloaderService.hidePreloader();
        that._alertService.error('Please try again .');
      });
    }

   
  }
  getStatusCounts(data: any[]): { [status: string]: number } {
    const counts: { [status: string]: number } = {};
    data.forEach(item => {
      const status = item.status || 'unknown';
      counts[status] = (counts[status] || 0) + 1;
    });
    return counts;
  }

  closeForm() {
    this.showReason = false;
    this.initializeForm();
  }
  setFormErrors() {
    this.formErrors = {
      'reasonlist': '',
    };
    this.validationMessages = {
      'reasonlist': {
        'required': 'Field is required.'
      }
    };
  }

  onChangeCertification (e) {
  //  if (e.target.value === 'Other') {
  //   this.showOther = true;
  //   this.deliverablesForm.controls['Other__c'].setValue(null);
  //   this.deliverablesForm.controls['Other__c'].setValidators([Validators.required]);
  //  }else{
  //    this.showOther = false;
  //     this.deliverablesForm.controls['Other__c'].setValidators(null);
  //     this.deliverablesForm.controls['Other__c'].setValue(null);
  //   }
  }

  onAddFiles(event: any,selectedId): void {
    const selectedFiles = event.target.files;
    for (let i = 0; i < selectedFiles.length; i++) {
      const f = selectedFiles[i];
      this.files.push({ name: f.name, size: String(f.size), status: 'Uploaded successfully' });
    }
    // handle upload logic here
    this.selectedFiles = Array.from(selectedFiles);
    this.upload(selectedId)
  }
  removeFile(index: number): void {
    this.files.splice(index, 1);
  }
}
